export const BORDER_COLOR = "var(--d-fill-color-neutral-060)"

const PERMITTED_TAGS = ["p", "br", "strong", "em", "a", "ul", "ol", "li"]

import createDOMPurify from "dompurify"

let purifier: ReturnType<typeof createDOMPurify> | null = null

function getPurifier() {
  if (!purifier) {
    purifier = createDOMPurify()

    purifier.addHook("afterSanitizeAttributes", (node) => {
      if (node.tagName === "A") {
        node.setAttribute("target", "_blank")
        node.setAttribute("rel", "noopener noreferrer")
      }
    })
  }

  return purifier
}

export function sanitize(html: string) {
  return getPurifier().sanitize(html, {
    ALLOWED_TAGS: PERMITTED_TAGS,
    ALLOWED_ATTR: ["href", "target", "rel"],
  })
}
